module.exports = __webpack_public_path__ + "static/media/tob.5d8dd14a.jpg";